import { useAuth } from "@/components/context/AuthContext"
import styles from "./banner.module.css"
import { ChartNoAxesColumn } from "lucide-react";

export default function TournamentBanner({ tournament, onEditClick, onDeleteClick, onStatusClick }) {
	const { user, isAuthenticated } = useAuth();

	const getStatusBadge = (status) => {
		switch (status) {
			case "upcoming":
				return { text: "Upcoming", color: "#7c3aed" }
			case "registration_open":
				return { text: "Registration Open", color: "#00d4ff" }
			case "registration_closed":
				return { text: "Registration Closed", color: "#ff6b6b" }
			case "ongoing":
				return { text: "Ongoing", color: "#00ff00" }
			case "completed":
				return { text: "Completed", color: "#808080" }
			case "cancelled":
				return { text: "Cancelled", color: "#ff4444" }
			default:
				return { text: "Coming Soon", color: "#7c3aed" }
		}
	}

	const statusBadge = getStatusBadge(tournament.status)

	return (
		<div className={styles.banner}>
			<div className={styles.bannerImage} style={{
				backgroundImage: `url(${tournament.bannerImage && tournament.bannerImage!=="undefined"
					? tournament.bannerImage
					: "/placeholder.webp"
					})`
			}} />
			<div className={styles.bannerOverlay} />

			{isAuthenticated && user?.role === "admin" && (
				<div className={styles.actionButtons}>
					<button className={styles.statusButton} onClick={onStatusClick} title="Update Status">
						<span><ChartNoAxesColumn /></span>
					</button>
					<button className={styles.editButton} onClick={onEditClick} title="Edit Tournament">
						<span>✎</span>
					</button>
					<button className={styles.deleteButton} onClick={onDeleteClick} title="Delete Tournament">
						<span>🗑</span>
					</button>
				</div>
			)}

			<div className={styles.bannerContent}>
				<div className={styles.gameBadge}>{tournament.game}</div>
				<h1 className={styles.title}>{tournament.name}</h1>
				<p className={styles.description}>{tournament.description}</p>
				<p className={styles.description}>{`Created By: ${tournament?.createdBy?.email}`}</p>

				<div className={styles.statusBadge} style={{ borderColor: statusBadge.color }}>
					<div className={styles.statusDot} style={{ backgroundColor: statusBadge.color }} />
					<span style={{ color: statusBadge.color }}>{statusBadge.text}</span>
				</div>
			</div>
		</div>
	)
}
